import {useQuery, useQueryClient} from '@tanstack/react-query';
import {apiClient} from '../../../../../utils/api-client';
import {TagsResponse} from '../interface';

function getAvailableTagsRequest() {
    return apiClient.get<TagsResponse>({
        path: 'editor-documents-service/api/documents/tags'
    });
}

export function useAvailableTagsQuery() {
    return useQuery({
        queryKey: ['available-tags'],
        queryFn: () => getAvailableTagsRequest()
    });
}

export function useAvailableTagsQueryCache() {
    const queryClient = useQueryClient();

    function invalidate() {
        queryClient.invalidateQueries({queryKey: ['available-tags']});
    }

    return {invalidate};
}
